// extracted by mini-css-extract-plugin
export var body = "_c2-0";
export var sectionHeader = "_c2-4";
export var shortcutColumns = "_c2-2";
export var shortcutList = "_c2-1";
export var shortcutSection = "_c2-3";